import {
  ICON_CHEVRON_DIRECTION,
  ICON_HEIGHT_12,
  ICON_HEIGHT_16,
  IconChevron,
} from '../../../../Icon'
import { PdfViewerFitMode } from '../../../PdfViewer.constants'

import ZoomOutIcon from '../../../../../icons/minimize.svg'
import ZoomInIcon from '../../../../../icons/plus.svg'

export const PDF_VIEWER_TOOLBAR_ZOOM_IN_ICON_PROPS = {
  Icon: ZoomInIcon,
  svgSize: ICON_HEIGHT_16,
}

export const PDF_VIEWER_TOOLBAR_ZOOM_OUT_ICON_PROPS = {
  Icon: ZoomOutIcon,
  svgSize: ICON_HEIGHT_16,
}

export const PDF_VIEWER_TOOLBAR_ZOOM_CHEVRON_ICON_PROPS = {
  Icon: IconChevron,
  iconProps: { direction: ICON_CHEVRON_DIRECTION.DOWN },
  svgSize: ICON_HEIGHT_12,
}

export const QA_NAME_PDF_VIEWER_TOOLBAR_ZOOM_VALUE_BTN =
  'pdfViewerToolbarZoomValue'

export const QA_NAME_PDF_VIEWER_TOOLBAR_ZOOM_IN_BTN = 'pdfViewerToolbarZoomIn'

export const QA_NAME_PDF_VIEWER_TOOLBAR_ZOOM_OUT_BTN = 'pdfViewerToolbarZoomOut'

export const PDF_VIEWER_ZOOM_SECTION_ID = {
  fitMode: 'fitMode',
  zoomPresets: 'zoomPresets',
}

export const PDF_VIEWER_ZOOM_PRESETS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4]

export const PDF_VIEWER_FIT_MODE_OPTIONS = [
  {
    qaName: 'pdfViewerFitWidth',
    titleKey: 'PdfViewer.FitWidthBtnKey',
    value: PdfViewerFitMode.PageWidth,
  },
  {
    qaName: 'pdfViewerFitPage',
    titleKey: 'PdfViewer.FitPageBtnKey',
    value: PdfViewerFitMode.PageFit,
  },
]
